import React from 'react';

import { SelectField, useRecordContext } from 'react-admin';

import { get } from 'lodash';

import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import booleanChoices from '../../../../constants/booleanChoices';
import conflictFields from '../../../../constants/conflictFields';
import { BooleanQuestionParameters } from '../../questionParameters';
import applyChoices from '../../applyChoices';

const CONTENT = {
  [languages.SV]: 'Ägs företaget av en stat, region, kommun eller motsvarande?',
  [languages.EN]: 'Is the company owned by a state, region, municipality or equivalent?',
  [languages.DE]: 'Gehört das Unternehmen einem Staat, einer Region, einer Gemeinde oder einer vergleichbaren öffentlichen Stelle?',
};

const ValueField = ({
  language,
  extraParameters,
}: {
  language?: Languages;
  extraParameters?: BooleanQuestionParameters;
}) => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  if (!language) return null;

  return (
    <SelectField
      choices={applyChoices(
        booleanChoices[language],
        extraParameters?.options,
        extraParameters?.choiceLabels,
      )}
      record={{ value }}
      sx={sx}
      source="value"
      emptyText="-"
      fontWeight="bold"
    />
  );
};

const StateOwned = ({ extraParameters }: { extraParameters?: BooleanQuestionParameters }) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? CONTENT[language]}
      source="stateOwned"
      datapoint={conflictFields.STATE_OWNED}
      identificationInfo={undefined}
    >
      <ValueField language={language} extraParameters={extraParameters} />
    </Answer>
  );
};

StateOwned.ValueField = ValueField;

export default StateOwned;
